module.exports = __webpack_public_path__ + "static/media/img_casks.c65f2bf6.png";